module.exports = __webpack_public_path__ + "static/media/pickup-icon.4b8091a8.svg";